import React, { useState } from 'react'
import { Box, useTheme, Button, Typography, Tooltip, Chip } from '@mui/material'
import { deleteButtonStyles } from './style'
import useUploadContactPhoto from '../../api/customHooks/useUploadContactPhoto'
import { useSnackbarContext } from '../../context/SnackbarProvider/SnackbarProvider'
import { Contact } from 'types'
import { GridApiPremium, GridRowSelectionModel } from '@mui/x-data-grid-premium'

const tooltipGridFooter = title => {
  return <Typography>{title}</Typography>
}

export const ContactsGridFooter = ({
  rowSelectionModel,
  onUpdate,
  anchorEl,
  setAnchorEl,
  onClickDelete,
  handleConfirmDelete,
  handleClosePopover,
  selectedData,
  setSelectedData,
  apiRef,
}: {
  rowSelectionModel: GridRowSelectionModel
  onUpdate: () => void
  anchorEl: HTMLElement | null
  setAnchorEl: React.Dispatch<React.SetStateAction<HTMLElement | null>>
  onClickDelete: (
    rowSelectionModel: GridRowSelectionModel,
    setAnchorEl: React.Dispatch<React.SetStateAction<HTMLElement | null>>,
    apiRef: React.RefObject<GridApiPremium>
  ) => void
  handleConfirmDelete: () => Promise<void>
  handleClosePopover: () => void
  selectedData: Contact
  setSelectedData: React.Dispatch<React.SetStateAction<Contact>>
  apiRef: React.RefObject<GridApiPremium>
}) => {
  const theme = useTheme()
  const { mutate: uploadMutation } = useUploadContactPhoto()
  const { showSnackbar } = useSnackbarContext()
  const [file, setFile] = useState(null)

  const handleFileChange = event => {
    const selectedFile = event.target.files[0]
    setFile(selectedFile)

    console.log('[handleFileChange] selectedFile:', selectedFile)
    console.log('[handleFileChange] selectedData:', selectedData)

    if (selectedFile && selectedData) {
      const formData = new FormData()
      formData.append('file', selectedFile)
      formData.append('contactId', selectedData.contacts_uuid)

      console.log('[handleFileChange] FormData:', formData.get('file'), formData.get('contactId'))

      uploadMutation(
        { formData },
        {
          onSuccess: data => {
            console.log('Photo uploaded successfully!', data)
            showSnackbar('Photo uploaded successfully!', 'success')

            setSelectedData(null)
          },
          onError: error => {
            console.error('Error uploading photo:', error)
            showSnackbar('Failed to upload photo. Please try again.', 'error') // Handle errors gracefully
          },
        }
      )
    }
  }

  const open = Boolean(anchorEl)
  const id = open ? 'contacts-grid-footer-popover' : undefined

  return (
    <>
      <Box
        sx={{
          maxHeight: 60,
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          p: 3,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          zIndex: 1,
          bgcolor: 'background.section',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Typography>{'Update'}</Typography>
          <Chip label={Array.from(rowSelectionModel?.ids)?.length} sx={{ color: 'rgb(24, 144, 255)', fontSize: 18 }} />
          <Typography> {Array.from(rowSelectionModel?.ids)?.length === 1 ? 'Contact' : 'Contacts'}</Typography>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mr: 10 }}>
          {Array.from(rowSelectionModel?.ids)?.length === 1 && (
            <>
              <input type="file" onChange={handleFileChange} style={{ display: 'none' }} id="contact-photo-upload" />
              <label htmlFor="contact-photo-upload" style={{ cursor: 'pointer' }}>
                <Tooltip title={tooltipGridFooter('Upload Photo')} placement="top">
                  <Button color="primary" variant="outlined" component="span">
                    Upload Photo
                  </Button>
                </Tooltip>
              </label>
              <Tooltip title={tooltipGridFooter('Delete')} placement="top">
                <Button
                  sx={deleteButtonStyles(theme)}
                  variant="outlined"
                  onClick={e => onClickDelete(rowSelectionModel, setAnchorEl, apiRef)}
                  color="secondary"
                >
                  Delete
                </Button>
              </Tooltip>
            </>
          )}
          {/* <Tooltip title={Array.from(rowSelectionModel?.ids)?.length === 1 ? 'Apply Update' : 'Apply Mass Update'} placement='top'> */}
          <Tooltip
            title={Array.from(rowSelectionModel?.ids)?.length === 1 ? 'Under Development...' : 'Under Development...'}
            placement="top"
          >
            <Box>
              <Button
                color="secondary"
                variant="contained"
                onClick={onUpdate}
                // disabled={Array.from(rowSelectionModel?.ids)?.length === 0}
                disabled
                sx={{ height: 40 }}
              >
                {Array.from(rowSelectionModel?.ids)?.length === 1 ? 'Update' : 'Mass Update'}
              </Button>
            </Box>
          </Tooltip>
        </Box>
      </Box>
      {/* <ContactsPopover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClosePopover}
        handleConfirmDelete={handleConfirmDelete}
        selectedData={selectedData}
      /> */}
    </>
  )
}
